import styled, { css } from "styled-components";
import { SuperButton } from "@swiggy-private/dls-web-core/dist/components/SuperButton";
import { getCornerRadius } from "@swiggy-private/dls-web-common/dist/components/themes/CornerRadiusMapping/mapping";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// Constants
const TEXT_TOP_MARGIN = "100px";

// Types for component props
interface ErrorProps {
    ux4?: boolean;
}

interface ErrorContentProps {
    ux4?: boolean;
    hasImage?: boolean;
    isToingAppFlow?: boolean;
}

interface ErrorImageProps {
    ux4?: boolean;
    halfHeight?: boolean;
    maxWidth?: number;
    maxHeight?: number;
}

// Removed ErrorTitle typography wrapper in favor of DLS Text

interface ErrorMsgProps {
    ux4?: boolean;
}

interface ErrorTextContentProps {
    ux4?: boolean;
}

// Main error container
export const ErrorContainer = styled.div<ErrorProps>`
    background-color: ${({ theme }) => theme.colors[theme.colorMode].background_Primary};
    height: 100%;
    overflow: hidden;
`;

// Error content wrapper
export const ErrorContent = styled.div<ErrorContentProps>`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.colors[theme.colorMode].background_Primary};
    flex-direction: column;
    text-align: center;
    height: 100%;
    padding-bottom: 32px;

    ${({ ux4, hasImage, isToingAppFlow }) =>
        ux4 &&
        !hasImage &&
        !isToingAppFlow &&
        css`
            position: absolute;
            width: 100%;
            right: 0;
            top: ${TEXT_TOP_MARGIN};
        `}
`;

// Error image
export const ErrorImage = styled.img<ErrorImageProps>`
    width: 100vw;
    height: calc(100vw * 0.675);
    object-fit: contain;
    object-position: center center;
    margin: 0 auto;

    ${({ maxWidth }) =>
        maxWidth != null &&
        css`
            max-width: ${maxWidth}px;
        `}

    ${({ maxHeight }) =>
        maxHeight != null &&
        css`
            max-height: ${maxHeight}px;
        `}

    ${({ ux4 }) =>
        ux4 &&
        css`
            width: 100vw;
            height: 75vh;
            position: fixed;
            object-fit: fill;
            bottom: 0;
            right: 0;
        `}

    ${({ halfHeight }) =>
        halfHeight &&
        css`
            height: 50vw;
            margin-bottom: 50px;
        `}
`;

// Error title

// ErrorTitle removed

// Error message
export const ErrorMsg = styled.div<ErrorMsgProps>`
    margin-top: 48px;
`;

// Error message when it follows title
export const ErrorMsgAfterTitle = styled(ErrorMsg)`
    margin-top: 4px;

    ${({ ux4 }) =>
        ux4 &&
        css`
            margin-top: 8px;
        `}
`;

// Second error message
export const ErrorSecondMsg = styled.div``;

// Text content wrapper
export const ErrorTextContent = styled.div<ErrorTextContentProps>`
    margin-top: 24px;
    padding: 0 60px;

    ${({ ux4 }) =>
        ux4 &&
        css`
            z-index: 1;
        `}
`;

// Back button
export const ErrorBackButton = styled.button`
    /* buttonReset mixin equivalent */
    background: none;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;

    position: absolute;
    top: 44px;
    left: 16px;
`;

export const ActionsSection = styled.div(({ theme }) => ({
    width: "100%",
    margin: `${theme.spacing.xLarge} ${theme.spacing.empty} ${theme.spacing.empty}`,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing.small,
    "& > div": {
        flex: 1,
    },
}));

export const ActionButton = styled(SuperButton)(({ theme }) => ({
    borderRadius: getCornerRadius(theme, "small"),
}));

export const QuickCheckoutErrorContainer = styled.div`
    background-color: ${({ theme }) => theme.colors[theme.colorMode].background_Primary};
    height: 100%;
    overflow: hidden;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: ${({ theme }) => `${theme.spacing.large} ${theme.spacing.medium} ${theme.spacing.xxLarge}`};
`;

export const QuickCheckoutErrorContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-color: ${({ theme }) => theme.colors[theme.colorMode].background_Primary};
    width: 100%;
    gap: 20px;
`;

export const QuickCheckoutErrorHeader = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: center;
    width: 100%;
    gap: 8px;
`;

export const QuickCheckoutErrorMessage = styled(Text)(() => ({}));

export const ButtonWrapper = styled.div({
    width: "100%",
    position: "relative",
});
